<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">
          <div class="headline">Dashboard</div>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-row>
            <v-col>
              <latest-updates :updates="this.activities" :loading="loading" />
            </v-col>
          </v-row>

          <v-row v-if="roleDashboard">
            <v-col>
              <component
                :is="roleDashboard"
                :tasks="tasks"
                :loading="tasksLoading"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LatestUpdates from '@/components/common/LatestUpdates'
import { mapGetters, mapActions } from 'vuex'
import AdminDashboard from './AdminDashboard'
import ClientDashboard from './ClientDashboard'
import ManagerDashboard from './ManagerDashboard'
import WorkerDashboard from './WorkerDashboard'

export default {
  name: 'BaseDashboard',
  components: {
    LatestUpdates,
    AdminDashboard,
    ClientDashboard,
    ManagerDashboard,
    WorkerDashboard
  },
  computed: {
    ...mapGetters('activityLogs', ['activities', 'loading']),
    ...mapGetters('tasks', {
      tasks: 'tasks',
      tasksLoading: 'loading'
    }),
    roleDashboard() {
      if (!this.$authUser || !this.$authUser.role) return

      return this.$authUser.role.name + '-dashboard'
    }
  },
  methods: {
    ...mapActions('activityLogs', ['fetchDashboardActivityLogs']),
    ...mapActions('tasks', ['fetchTasks'])
  },
  created() {
    this.fetchDashboardActivityLogs()
    this.fetchTasks()
  }
}
</script>
